import borderRadius from "./radius";
import colors from "./colors";
import textStyles from "./textStyle";

export default {
  colors,
  textStyles,
  borderRadius,
};
